<template>
    <!-- Left Sidebar -->
    <aside id="leftsidebar" class="sidebar">
        <!-- User Info -->
        <div class="user-info" v-if="!loading">
            <div class="image">
                <img :src="user_image" width="48" height="48" alt="User" v-if="user_image" />
                <img src="static/images/money.png" width="48" height="48" alt="User" v-else />
            </div>
            <div class="info-container">
                <div class="name">{{ user.username }}</div>
                <div class="btn-group user-helper-dropdown">
                    <i class="material-icons" data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="true">keyboard_arrow_down</i>
                    <ul class="dropdown-menu pull-right">
                        <li>
                            <router-link to="/user-profile">
                                <i class="material-icons">person</i>
                                <span>Profile</span>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/logout">
                                <i class="material-icons">input</i>
                                <span>Log Out</span>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- #User Info -->
        <!-- Menu -->
        <div class="menu">
            <ul class="list">
                <!--<li class="header"></li>-->
                <li>
                    <router-link id="menu-user" to="/dashboard">
                        <i class="material-icons">dashboard</i>
                        <span>Dashboard</span>
                    </router-link>
                </li>
                <li v-if="user.role_id == 1 || user.role_id == 2">
                    <router-link id="menu-user" to="/package-record">
                        <i class="material-icons">save</i>
                        <span>บันทึกแพคเกจ</span>
                    </router-link>
                </li>
                <li>
                    <router-link id="menu-user" to="/package-list">
                        <i class="material-icons">view_list</i>
                        <span>แสดงรายการแพคเกจ</span>
                    </router-link>
                </li>
                      <li>
                            <a href="javascript:void(0);" class="menu-toggle">

                                <i class="material-icons">attach_money</i>
                                <span>ประวัติการเติมเงิน</span>
                            </a>
                            <ul class="ml-menu" id="ml-cashcard">
                                 <li>
                                    <router-link to="/topup-game">
                                        <i class="material-icons" style="font-size: 12px;">fiber_manual_record</i>
                                        <span>ประวัติการเติมเกมส์</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/topup-credit">

                                        <i class="material-icons" style="font-size: 12px;">fiber_manual_record</i>
                                        <span>ประวัติการเติมเครดิต</span>
                                    </router-link>
                                </li>
                               
                                <li>
                                    <router-link to="/topup-mobile">

                                        <i class="material-icons" style="font-size: 12px;">fiber_manual_record</i>
                                        <span>ประวัติการเติมเงินมือถือ</span>
                                    </router-link>
                                </li>
                                 <li>
                                    <router-link to="/credit-log">

                                        <i class="material-icons" style="font-size: 12px;">fiber_manual_record</i>
                                        <span>เครดิตคงเหลือของสมาชิก</span>
                                    </router-link>
                                </li>
                                 <li>
                                    <router-link to="/wepay-log">

                                        <i class="material-icons" style="font-size: 12px;">fiber_manual_record</i>
                                        <span>Wepay Log</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>

                <!-- <li v-if="roles.admin"> -->
                <li v-if="user.role_id == 1">
                    <a href="javascript:void(0);" class="menu-toggle">
                        <img :src="(this.$route.meta.group == 'user') ? 'static/images/user-settings-active.png' : 'static/images/user-settings.png'"
                            class="user-img">
                        <span>ผู้ดูแลระบบ</span>
                    </a>
                    <ul class="ml-menu" id="ml-worklist">
                        <li>
                            <router-link to="/member-manage">
                                <i class="material-icons">group</i>
                                <span>การจัดการสมาชิก</span>
                            </router-link>
                        </li>
                        <li>
                            <a href="javascript:void(0);" class="menu-toggle">

                                <i class="material-icons">gamepad</i>
                                <span>การจัดการเกม</span>
                            </a>
                            <ul class="ml-menu" id="ml-game">
                                <li>
                                    <router-link to="/game-manage">

                                        <i class="material-icons" style="font-size: 12px;">fiber_manual_record</i>
                                        <span>การจัดการเกม</span>
                                    </router-link>
                                </li>
                                 <li>
                                    <router-link to="/uid-image-manage">

                                        <i class="material-icons" style="font-size: 12px;">fiber_manual_record</i>
                                        <span>รูปภาพ UID</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/game-package-manage">

                                        <i class="material-icons" style="font-size: 12px;">fiber_manual_record</i>
                                        <span>การจัดการแพคเกจ</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/flash-package-manage">

                                        <i class="material-icons" style="font-size: 12px;">fiber_manual_record</i>
                                        <span>การจัดการแฟลชเซลล์</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>

                        <li>
                            <a href="javascript:void(0);" class="menu-toggle">

                                <i class="material-icons">phonelink_setup</i>
                                <span>การจัดการเติมเงินมือถือ</span>
                            </a>
                            <ul class="ml-menu" id="ml-mobile">
                                <li>
                                    <router-link to="/mobile-manage">

                                        <i class="material-icons" style="font-size: 12px;">fiber_manual_record</i>
                                        <span>การจัดการค่ายมือถือ</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/mobile-package-manage">

                                        <i class="material-icons" style="font-size: 12px;">fiber_manual_record</i>
                                        <span>การจัดการแพคเกจ</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>

                        <li>
                            <a href="javascript:void(0);" class="menu-toggle">

                                <i class="material-icons">credit_card</i>
                                <span>การจัดการบัตรเติมเกม</span>
                            </a>
                            <ul class="ml-menu" id="ml-cashcard">
                                <li>
                                    <router-link to="/card-manage">

                                        <i class="material-icons" style="font-size: 12px;">fiber_manual_record</i>
                                        <span>การจัดการบัตรเติมเกม</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/card-package-manage">

                                        <i class="material-icons" style="font-size: 12px;">fiber_manual_record</i>
                                        <span>การจัดการแพคเกจ</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>

                  

                           <li>
                            <a href="javascript:void(0);" class="menu-toggle">

                                <i class="material-icons">credit_card</i>
                                <span>การจัดการข้อมูล</span>
                            </a>
                            <ul class="ml-menu" id="ml-data">
                                <li>
                                    <router-link to="/image-manage">

                                        <i class="material-icons" style="font-size: 12px;">fiber_manual_record</i>
                                        <span>รูปภาพหน้าหลัก</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/bank-account-manage">

                                        <i class="material-icons" style="font-size: 12px;">fiber_manual_record</i>
                                        <span>บัญชีธนาคาร</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/contact-manage">

                                        <i class="material-icons" style="font-size: 12px;">fiber_manual_record</i>
                                        <span>ข้อมูลการติดต่อ</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>

                        <li>
                            <router-link to="/package-manage">
                                <i class="material-icons">group_work</i>
                                <span>การจัดการแพคเกจ</span>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/user-manage">
                                <i class="material-icons" style="margin-top: 0"
                                    :class="{ 'active': this.$route.name.indexOf('user') > -1 }">person</i>
                                <span>ผู้ใช้งานระบบ</span>
                            </router-link>
                        </li>


                    </ul>
                </li>







            </ul>
        </div>

    </aside>
    <!-- #END# Left Sidebar -->
</template>

<script>
import Waves from '../../static/plugins/node-waves/waves.js'
import '../../static/plugins/jquery-slimscroll/jquery.slimscroll.js'

export default {
    name: "SideBar",
    data() {
        return {
            user: JSON.parse(localStorage.getItem('user')),
            require_auth: false,
            env: process.env.NODE_ENV,
            base_path: process.env.HOST,
            user_image: null,
            intervalTime: 600000,
            leftSideBar: {
                scrollColor: 'rgba(0,0,0,0.5)',
                scrollWidth: '4px',
                scrollAlwaysVisible: false,
                scrollBorderRadius: '0',
                scrollRailBorderRadius: '0',
                scrollActiveItemWhenPageLoad: true,
                breakpointWidth: 1170
            },
            loading: false
        }
    },
    async created() {


    },
    mounted() {


        setTimeout(() => {
            this.activate();


        }, 500);

    },
    methods: {

        activate() {

            var _this = this;
            var $body = $('body');
            var $overlay = $('.overlay');
            //Close sidebar
            $(window).click(function (e) {
                var $target = $(e.target);
                if (e.target.nodeName.toLowerCase() == 'i') { $target = $(e.target).parent(); }

                if (!$target.hasClass('bars') && _this.isOpen() && $target.parents('#leftsidebar').length == 0) {
                    if (!$target.hasClass('js-right-sidebar')) $overlay.fadeOut();
                    $body.removeClass('overlay-open');
                }
            });

            $.each($('.menu-toggle.toggled'), function (i, val) {
                $(val).next().slideToggle(0);
            });

            //When page load
            $.each($('.menu .list li.active'), function (i, val) {
                var $activeAnchors = $(val).find('a:eq(0)');

                $activeAnchors.addClass('toggled');
                $activeAnchors.next().show();
            });

            //Collapse or Expand Menu
            $('.menu-toggle').on('click', function (e) {
                var $this = $(this);
                var $content = $this.next();

                if ($($this.parents('ul')[0]).hasClass('list')) {
                    var $not = $(e.target).hasClass('menu-toggle') ? e.target : $(e.target).parents('.menu-toggle');

                    $.each($('.menu-toggle.toggled').not($not).next(), function (i, val) {
                        if ($(val).is(':visible')) {
                            $(val).prev().toggleClass('toggled');
                            $(val).slideUp();
                        }
                    });
                }

                $this.toggleClass('toggled');
                $content.slideToggle(320);
            });

            //Set menu height
            _this.setMenuHeight(true);
            _this.checkStatusForResize(true);
            $(window).resize(function () {
                _this.setMenuHeight(false);
                _this.checkStatusForResize(false);
            });

            //Set Waves
            Waves.attach('.menu .list a', ['waves-block']);
            Waves.init();
            // _this.getWorklist();
            //if(!_this.require_auth){
            //  $('#leftsidebar').hide()
            // }
        },
        setMenuHeight(isFirstTime) {
            if (typeof $.fn.slimScroll != 'undefined') {
                var configs = this.leftSideBar;
                var height = ($(window).height() - ($('.legal').outerHeight() + $('.user-info').outerHeight() + $('.navbar').innerHeight()));
                var $el = $('.list');

                if (!isFirstTime) {
                    $el.slimscroll({
                        destroy: true
                    });
                }

                $el.slimscroll({
                    height: height + "px",
                    color: configs.scrollColor,
                    size: configs.scrollWidth,
                    alwaysVisible: configs.scrollAlwaysVisible,
                    borderRadius: configs.scrollBorderRadius,
                    railBorderRadius: configs.scrollRailBorderRadius
                });

                //Scroll active menu item when page load, if option set = true
                if (this.leftSideBar.scrollActiveItemWhenPageLoad) {
                    var item = $('.menu .list li.active')[0];
                    if (item) {
                        var activeItemOffsetTop = item.offsetTop;
                        if (activeItemOffsetTop > 150) $el.slimscroll({ scrollTo: activeItemOffsetTop + 'px' });
                    }
                }
            }
        },
        checkStatusForResize(firstTime) {
            var $body = $('body');
            var $openCloseBar = $('.navbar .navbar-header .bars');
            var width = $body.width();

            if (firstTime) {
                $body.find('.content, .sidebar').addClass('no-animate').delay(1000).queue(function () {
                    $(this).removeClass('no-animate').dequeue();
                });
            }

            if (width < this.leftSideBar.breakpointWidth) {
                $body.addClass('ls-closed');
                $openCloseBar.fadeIn();
            }
            else {
                $body.removeClass('ls-closed');
                $openCloseBar.fadeOut();
            }
        },
        isOpen() {
            return $('body').hasClass('overlay-open');
        },
        closeMenu() {
            var $body = $('body');
            var $openCloseBar = $('.navbar .navbar-header .bars');
            $body.addClass('ls-closed');
            $openCloseBar.fadeIn();
        }
    }
}



</script>

<style scoped>
.sidebar {
    top: 77px;
}

.list {
    padding-bottom: 30px;
}

.fn-label-count {
    position: absolute;
    font-size: 10px;
    font-weight: bold;
    margin-left: 1px;
    font-size: 10px;
    line-height: 15px;
    background-color: #f44336;
    padding: 0 4px;
    border-radius: 3px;
}

.material-icons.active {
    color: orange;
}

.fn-label-count.active {
    background-color: #FFC107;
}

.user-info {
    background: url("../../static/images/user-img-background.jpg") no-repeat no-repeat;
}

.sidebar .user-info .info-container .user-helper-left {
    position: absolute;
    top: -79px;
    right: -7px;
    bottom: -12px;
    -webkit-box-shadow: none;
    -ms-box-shadow: none;
    box-shadow: none;
    cursor: pointer;
    color: #fff;
}

.sidebar .menu .list a {
    padding-bottom: 5px;
}

.sidebar .menu .list .ml-menu span {
    margin-left: 10px;
}

.user-img {
    width: 22px;
    height: 22px;
    margin-top: 5px;
}

.line-img {
    width: 20px;
    height: 20px;
    margin-top: 3px;
}

.customer-img {
    width: 22px;
    height: 22px;
    margin-top: 0px;
}

.agent-img {
    width: 20px;
    height: 20px;
    margin-top: 0px;
}

.team-img {
    width: 19px;
    height: 19px;
    margin-top: 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/SideBar.vue